/**
 * Статусы участника: коды, подписи и иконки.
 *
 * Набор фиксирован и согласован с бэкендом — `docs/participant-status-api.md`.
 * Сервер хранит и отдаёт только код, подпись рисует клиент на языке
 * смотрящего: если положить в базу строку «Ищу встречи», англоязычный
 * участник увидит русский текст.
 *
 * По той же причине набор не приходит с сервера, хотя фильтры каталога
 * приходят. Позже на эти коды лягут правила уведомлений («Не беспокоить»
 * глушит push), а правило пишется на код, не на подпись. Конфиг мероприятия —
 * какие коды включены и как подписаны — отдельная задача, в первую итерацию
 * не входит.
 *
 * Отсутствие статуса — `null`, своего кода у него нет: в списке выбора это
 * первая строка, в профиле не показывается ничем.
 *
 * Не миксин, обычный модуль с данными. Лежит рядом с `businessCardFields.js`,
 * который устроен так же.
 */

/** В порядке показа: от «сам ищу контакта» до «не пишите». */
export const PARTICIPANT_STATUSES = [
  {
    code: 'looking_for_meetings',
    labelKey: 'shared.participantStatus.looking_for_meetings',
    icon: 'exu-user-meeting',
  },
  {
    code: 'available',
    labelKey: 'shared.participantStatus.available',
    icon: 'exu-message-chat-square',
  },
  {
    code: 'in_session',
    labelKey: 'shared.participantStatus.in_session',
    icon: 'exu-mic',
  },
  {
    code: 'do_not_disturb',
    labelKey: 'shared.participantStatus.do_not_disturb',
    icon: 'exu-bell-off-03',
  },
];

/**
 * Описатель по коду или `null`.
 *
 * Незнакомый код экран ронять не должен: сервер может отдать статус, которого
 * эта сборка ещё не знает, — показываем как отсутствие статуса. Пустая строка
 * попадает туда же, и это не теория: на стенде снятие статуса какое-то время
 * записывало `""` вместо `null`.
 */
export function findStatus(code) {
  if (!code) return null;
  return PARTICIPANT_STATUSES.find((item) => item.code === code) || null;
}
